<template>
  <!-- 下拉格式 -->
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-select v-model="formInline[item.key]"
    :placeholder="getValue(item, 'placeholder', null) || selectPlaceholder"
    :clearable="getValue(item, 'clearable', false)"
    :multiple="getValue(item, 'multiple', false)"
    :disabled="getValue(item, 'disabled', false)"
    :filter-method="getValue(item, 'filterMethod', null)"
    :filterable="
      getValue(item, 'filterable', false) ||
      !!getValue(item, 'remoteMthod', null)
    "
    :remote="!!getValue(item, 'remoteMthod', null)"
    :remote-method="getValue(item, 'remoteMthod', null)"
    :loading="getValue(item, 'loading', false)"
    @change="(event) => changeSelect(event, item)"
    maxlength="10"
  >
    <template v-if="!Array.isArray(item.source)">
      <el-option
        v-for="(item, key) in item.source"
        :key="key"
        :label="item"
        :value="key"
      >
        <jsx-template
          v-if="item.options && typeof item.options.jsxRender === 'function'"
          :jsxRender="item.options.jsxRender && item.options.jsxRender(item)"
        />
      </el-option>
    </template>

    <template v-else>
      <el-option
        v-for="sitem in item.source"
        :key="sitem[
          item.sourceKey && item.sourceKey.value
            ? item.sourceKey.value
            : 'value'
        ]"
        :label="
          sitem[
            item.sourceKey && item.sourceKey.label
              ? item.sourceKey.label
              : 'label'
          ]
        "
        :value="
          sitem[
            item.sourceKey && item.sourceKey.value
              ? item.sourceKey.value
              : 'value'
          ]
        "
      >
        <jsx-template
          v-if="item.options && typeof item.options.jsxRender  === 'function'"
          :jsxRender="item.options.jsxRender && item.options.jsxRender(sitem)"
        />
      </el-option>
    </template>
  </el-select>
</template>

<script>
import JsxTemplate from './jsxTemplate.vue'

export default {
  components: {
    JsxTemplate,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
}
</script>
